import React from 'react';
import { WarningPanel, CodeSnippet } from '@backstage/core-components';
import { Button } from '@material-ui/core';

interface TPErrorBoundaryProps {
  children: React.ReactNode;
  title?: string;
}

interface TPErrorBoundaryState {
  hasError: boolean;
  errorMessage?: string;
}

class TPErrorBoundary extends React.Component<
  TPErrorBoundaryProps,
  TPErrorBoundaryState
> {
  state: TPErrorBoundaryState = {
    hasError: false,
  };

  static getDerivedStateFromError(error: Error): TPErrorBoundaryState {
    return {
      hasError: true,
      errorMessage: error?.message || 'Unexpected error',
    };
  }

  componentDidCatch() {
    // Intentionally left blank; we only prevent white screen and show fallback UI.
  }

  handleRetry = () => {
    this.setState({ hasError: false, errorMessage: undefined });
  };

  render() {
    if (this.state.hasError) {
      return (
        <WarningPanel
          severity="error"
          title={this.props.title || 'Unable to load this section'}
        >
          <CodeSnippet language="text" text={this.state.errorMessage || 'Unexpected error'} />
          <Button color="primary" variant="contained" onClick={this.handleRetry}>
            Retry
          </Button>
        </WarningPanel>
      );
    }

    return this.props.children;
  }
}

export default TPErrorBoundary;
